<template>
  <transition name="balance-billing-fade">
    <div
      v-if="balanceBillingGate.visible"
      class="balance-billing-root fixed inset-0 z-[10055] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="余额与账单"
    >
      <div class="absolute inset-0 bg-black/75 backdrop-blur-md" @click="onClose"></div>
      <div
        class="balance-billing-panel relative z-10 flex w-full max-w-[820px] flex-col overflow-hidden rounded-[20px] border border-white/[0.06] bg-[#0a0a0c] text-white shadow-2xl"
        @click.stop
      >
        <!-- 顶栏：与积分充值弹窗一致 -->
        <div class="flex shrink-0 items-center justify-between px-6 pb-2 pt-5">
          <h2 class="text-[18px] font-bold tracking-tight text-white">{{ panelTitle }}</h2>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-full bg-white/[0.06] text-white/50 transition hover:bg-white/10 hover:text-white"
            aria-label="关闭"
            @click="onClose"
          >
            <i class="fas fa-times text-[13px]"></i>
          </button>
        </div>

        <div class="flex min-h-0 flex-1 overflow-hidden">
          <!-- 左侧导航 -->
          <aside
            class="hidden h-full w-[148px] shrink-0 flex-col border-r border-white/[0.05] px-3 py-2 sm:flex"
          >
            <nav class="flex-1 space-y-0.5">
              <button
                type="button"
                class="bb-nav-btn w-full rounded-[10px] px-3 py-2.5 text-left text-[12px] font-medium transition"
                :class="
                  sideNav === 'balance'
                    ? 'bg-white/[0.06] text-white'
                    : 'text-white/40 hover:bg-white/[0.04] hover:text-white/75'
                "
                @click="onSideNav('balance')"
              >
                余额与账单
              </button>
              <button
                type="button"
                class="bb-nav-btn w-full rounded-[10px] px-3 py-2.5 text-left text-[12px] transition"
                :class="
                  sideNav === 'profile'
                    ? 'bg-white/[0.06] text-white'
                    : 'text-white/40 hover:bg-white/[0.04] hover:text-white/75'
                "
                @click="onSideNav('profile')"
              >
                编辑资料
              </button>
              <button
                type="button"
                class="bb-nav-btn w-full rounded-[10px] px-3 py-2.5 text-left text-[12px] transition"
                :class="
                  sideNav === 'invite'
                    ? 'bg-white/[0.06] text-white'
                    : 'text-white/40 hover:bg-white/[0.04] hover:text-white/75'
                "
                @click="onSideNav('invite')"
              >
                邀请好友
              </button>
              <button
                type="button"
                class="bb-nav-btn w-full rounded-[10px] px-3 py-2.5 text-left text-[12px] transition"
                :class="
                  sideNav === 'redeem'
                    ? 'bg-white/[0.06] text-white'
                    : 'text-white/40 hover:bg-white/[0.04] hover:text-white/75'
                "
                @click="onSideNav('redeem')"
              >
                卡密兑换
              </button>
            </nav>
            <button
              type="button"
              class="bb-logout-btn mt-auto w-full shrink-0 rounded-[10px] px-3 py-2.5 text-left text-[12px] text-red-400/85 transition hover:bg-red-500/10 hover:text-red-300 sm:inline-flex sm:items-center sm:gap-2"
              @click="onLogout"
            >
              <i class="fas fa-right-from-bracket text-[11px]"></i>
              退出登录
            </button>
          </aside>

          <!-- 主内容 -->
          <div class="flex min-w-0 flex-1 flex-col">
            <div
              class="min-h-0 flex-1 px-6 pb-4"
              :class="
                sideNav === 'balance'
                  ? 'flex flex-col overflow-hidden'
                  : 'overflow-y-auto [-ms-overflow-style:none] [scrollbar-width:thin]'
              "
            >
              <!-- 移动端 Tab 导航 -->
              <div class="mb-4 flex gap-1 overflow-x-auto sm:hidden">
                <button
                  v-for="item in sideNavItems"
                  :key="item.key"
                  type="button"
                  class="bb-nav-btn shrink-0 rounded-[10px] px-3 py-2 text-[12px]"
                  :class="sideNav === item.key ? 'bg-white/[0.06] text-white' : 'text-white/40'"
                  @click="onSideNav(item.key)"
                >
                  {{ item.label }}
                </button>
              </div>

              <template v-if="sideNav === 'balance'">
                <div class="bbm-balance-layout flex min-h-0 flex-1 flex-col">
                <!-- 用户信息条（同积分充值） -->
                <div
                  class="bbm-user-bar mb-5 flex flex-wrap items-center justify-between gap-3 rounded-[14px] border border-white/[0.06] bg-white/[0.03] px-4 py-3"
                >
                  <div class="flex min-w-0 items-center gap-3">
                    <div
                      class="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-[#161618]"
                    >
                      <img v-if="summary.avatar" :src="summary.avatar" alt="" class="h-full w-full object-cover" />
                      <i v-else class="fas fa-user text-sm text-white/50"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="truncate text-[14px] font-medium text-white/95">
                        {{ summary.name || '用户' }}
                      </div>
                      <div class="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[11px] text-white/40">
                        <span class="shrink-0">目前是</span>
                        <span
                          class="bbm-vip-badge inline-flex shrink-0 items-center rounded-md px-1.5 py-0.5 text-[11px] font-semibold leading-none"
                          :class="vipnameBadgeClass"
                        >
                          {{ summary.vipname || 'FREE' }}
                        </span>
                        <span v-if="summary.vipEndAt" class="text-white/35">
                          有效期至 {{ formatVipEndAt(summary.vipEndAt) }}
                        </span>
                        <button
                          v-if="!summary.isMember"
                          type="button"
                          class="text-sky-300/90 transition hover:text-sky-200"
                          @click="onUpgrade"
                        >
                          升级获取积分 &gt;
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center gap-1.5 text-[13px]">
                    <span class="text-white/45">总积分</span>
                    <span class="bbm-coin-icon inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center">
                      <i class="fas fa-coins text-[11px] text-amber-300"></i>
                    </span>
                    <span class="text-[22px] font-bold tabular-nums tracking-tight text-white/95">
                      {{ formatNum(summary.total) }}
                    </span>
                  </div>
                </div>

                <!-- 余额分区卡片 -->
                <div class="bbm-stat-grid mb-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
                  <div class="bbm-stat-card rounded-[14px] border border-white/[0.06] px-4 py-3">
                    <div class="text-[11px] text-white/40">通用积分</div>
                    <div class="mt-2 flex items-baseline gap-1.5">
                      <span class="text-[20px] font-bold tabular-nums text-white">
                        {{ formatNum(summary.generalAvailable) }}
                      </span>
                      <span class="bbm-coin-icon inline-flex h-4 w-4 items-center justify-center">
                        <i class="fas fa-coins text-[9px] text-amber-300/95"></i>
                      </span>
                    </div>
                    <div class="mt-1 text-[11px] text-white/32">
                      冻结 {{ formatNum(summary.generalFrozen) }}
                    </div>
                  </div>
                  <div class="bbm-stat-card rounded-[14px] border border-white/[0.06] px-4 py-3">
                    <div class="text-[11px] text-white/40">模型积分</div>
                    <div class="mt-2 flex items-baseline gap-1.5">
                      <span class="text-[20px] font-bold tabular-nums text-white">
                        {{ formatNum(summary.modelAvailable) }}
                      </span>
                      <span class="bbm-coin-icon inline-flex h-4 w-4 items-center justify-center">
                        <i class="fas fa-coins text-[9px] text-amber-300/95"></i>
                      </span>
                    </div>
                    <div class="mt-1 text-[11px] text-white/32">
                      冻结 {{ formatNum(summary.modelFrozen) }}
                    </div>
                  </div>
                </div>

                <!-- 订阅 / 充值 / 其他 -->
                <!-- <div class="mb-5 grid grid-cols-3 gap-3">
                  <div
                    v-for="stat in statItems"
                    :key="stat.key"
                    class="bbm-stat-card rounded-[14px] border border-white/[0.06] px-3 py-3 text-center"
                  >
                    <div class="flex items-center justify-center gap-1 text-[11px] text-white/40">
                      <span>{{ stat.label }}</span>
                      <i class="fas fa-circle-info text-[9px] text-white/22" :title="stat.tip"></i>
                    </div>
                    <div class="mt-1.5 text-[17px] font-bold tabular-nums text-white/90">
                      {{ formatNum(stat.value) }}
                    </div>
                  </div>
                </div> -->

                <!-- 筛选：全部 / 消耗 / 获得 -->
                <div class="relative z-10 mb-4 flex flex-wrap items-center justify-between gap-3">
                  <div class="inline-flex rounded-full bg-white/[0.04] p-0.5">
                    <button
                      v-for="tab in recordFilterTabs"
                      :key="tab.key"
                      type="button"
                      class="bb-nav-btn rounded-full px-4 py-1.5 text-[12px] font-medium transition"
                      :class="
                        filterType === tab.key
                          ? 'bg-white/[0.08] text-white'
                          : 'text-white/40 hover:text-white/65'
                      "
                      @click="setRecordFilter(tab.key)"
                    >
                      {{ tab.label }}
                    </button>
                  </div>
                  <button type="button" class="text-[11px] text-white/32 transition hover:text-sky-300/90">
                    积分规则
                  </button>
                </div>

                <div class="bbm-records-panel flex min-h-0 flex-1 flex-col">
                  <div
                    class="bbm-table-head shrink-0 grid grid-cols-[1fr_auto_auto_auto] gap-2 border-b border-white/[0.05] pb-2 text-[11px] text-white/35"
                  >
                    <span>详情</span>
                    <span class="w-[72px] text-center">类型</span>
                    <span class="w-[128px] text-center">日期</span>
                    <span class="w-[80px] text-right">余额变动</span>
                  </div>

                  <div
                    ref="recordsScrollEl"
                    class="bbm-table-scroll min-h-0 flex-1 overflow-y-auto [-ms-overflow-style:none] [scrollbar-width:thin]"
                    @scroll.passive="onRecordsScroll"
                  >
                    <div
                      v-if="recordsLoading && !records.length"
                      class="py-12 text-center text-[12px] text-white/30"
                    >
                      加载中…
                    </div>
                    <div
                      v-else-if="!recordsLoading && !records.length"
                      class="py-12 text-center text-[12px] text-white/30"
                    >
                      暂无流水记录
                    </div>
                    <template v-else>
                      <div class="divide-y divide-white/[0.04]">
                        <div
                          v-for="row in records"
                          :key="row.id"
                          class="grid grid-cols-[1fr_auto_auto_auto] items-center gap-2 py-3 text-[12px]"
                        >
                          <span class="truncate text-white/85">{{ row.title }}</span>
                          <span class="w-[72px] text-center text-white/38">{{ row.typeLabel }}</span>
                          <span class="w-[128px] text-center tabular-nums text-white/38">{{
                            formatDate(row.date)
                          }}</span>
                          <span
                            class="w-[80px] text-right font-semibold tabular-nums"
                            :class="
                              row.change < 0
                                ? 'text-red-400/95'
                                : row.change > 0
                                  ? 'text-amber-300/90'
                                  : 'text-white/45'
                            "
                          >
                            {{ formatChange(row.change) }}
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="recordsLoadingMore"
                        class="py-4 text-center text-[11px] text-white/30"
                      >
                        <i class="fas fa-spinner fa-spin mr-1"></i>加载更多…
                      </div>
                      <div
                        v-else-if="!recordsHasMore && records.length"
                        class="py-3 text-center text-[11px] text-white/22"
                      >
                        没有更多了
                      </div>
                    </template>
                  </div>
                </div>
                </div>
              </template>

              <template v-else-if="sideNav === 'profile'">
                <div class="bbm-profile-form mx-auto max-w-[420px] py-2">
                  <div class="mb-6 flex flex-col items-center">
                    <label
                      class="bbm-avatar-picker"
                      :class="{ 'bbm-avatar-picker--disabled': avatarUploading }"
                      aria-label="上传头像"
                    >
                      <input
                        ref="avatarFileInput"
                        type="file"
                        accept="image/jpeg,image/png,image/gif,image/webp"
                        class="bbm-avatar-picker__input"
                        :disabled="avatarUploading"
                        @change="onAvatarFileChange"
                      />
                      <span class="bbm-avatar-picker__ring">
                        <img
                          v-if="profileForm.avatar"
                          :src="profileForm.avatar"
                          alt=""
                          class="bbm-avatar-picker__img"
                        />
                        <i v-else class="fas fa-user bbm-avatar-picker__placeholder"></i>
                        <span v-if="avatarUploading" class="bbm-avatar-picker__loading">
                          <i class="fas fa-spinner fa-spin text-[14px]"></i>
                        </span>
                      </span>
                      <span class="bbm-avatar-picker__edit" aria-hidden="true">
                        <i class="fas fa-pen text-[10px]"></i>
                      </span>
                    </label>
                    <p class="mt-3 text-[11px] text-white/35">点击头像上传，将显示在侧栏与账户相关页面</p>
                  </div>

                  <label class="bbm-field">
                    <span class="bbm-field__label">昵称</span>
                    <input
                      v-model.trim="profileForm.name"
                      type="text"
                      maxlength="32"
                      class="bbm-field__input"
                      placeholder="请输入昵称"
                    />
                  </label>

                  <p v-if="profileError" class="mt-3 text-center text-[12px] text-red-400/90">{{ profileError }}</p>
                  <p v-if="profileSuccess" class="mt-3 text-center text-[12px] text-emerald-400/90">
                    {{ profileSuccess }}
                  </p>

                  <div class="mt-8 flex justify-center">
                    <button
                      type="button"
                      class="bbm-pay-btn inline-flex min-w-[200px] items-center justify-center gap-2 rounded-full px-8 py-3 text-[15px] font-bold text-[#0c0c0e] transition active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-45"
                      :disabled="profileSaving || !profileForm.name"
                      @click="saveProfile"
                    >
                      {{ profileSaving ? '保存中…' : '保存资料' }}
                    </button>
                  </div>
                </div>
              </template>

              <template v-else-if="sideNav === 'invite'">
                <div class="py-20 text-center">
                  <i class="fas fa-user-plus mb-4 text-3xl text-white/18"></i>
                  <p class="text-[13px] text-white/40">邀请好友功能即将上线</p>
                  <p class="mt-2 text-[11px] text-white/28">敬请期待</p>
                </div>
              </template>

              <template v-else-if="sideNav === 'redeem'">
                <div class="bbm-redeem-form mx-auto max-w-[420px] py-6">
                  <div class="mb-6 text-center">
                    <div
                      class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-400/20 bg-amber-400/[0.08]"
                    >
                      <i class="fas fa-ticket-alt text-xl text-amber-300/90"></i>
                    </div>
                    <p class="text-[14px] font-medium text-white/90">卡密兑换</p>
                    <p class="mt-2 text-[11px] leading-relaxed text-white/38">
                      输入卡密后可兑换积分或会员权益，兑换成功后将自动到账
                    </p>
                  </div>

                  <label class="bbm-field">
                    <span class="bbm-field__label">卡密</span>
                    <input
                      v-model.trim="redeemForm.code"
                      type="text"
                      maxlength="64"
                      class="bbm-field__input bbm-field__input--mono"
                      placeholder="请输入卡密"
                      autocomplete="off"
                      spellcheck="false"
                      @keyup.enter="submitRedeemCode"
                    />
                  </label>

                  <p v-if="redeemError" class="mt-3 text-center text-[12px] text-red-400/90">{{ redeemError }}</p>
                  <p v-if="redeemSuccess" class="mt-3 text-center text-[12px] text-emerald-400/90">
                    {{ redeemSuccess }}
                  </p>

                  <div class="mt-8 flex justify-center">
                    <button
                      type="button"
                      class="bbm-pay-btn inline-flex min-w-[200px] items-center justify-center gap-2 rounded-full px-8 py-3 text-[15px] font-bold text-[#0c0c0e] transition active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-45"
                      :disabled="redeemSubmitting || !redeemForm.code"
                      @click="submitRedeemCode"
                    >
                      {{ redeemSubmitting ? '兑换中…' : '立即兑换' }}
                    </button>
                  </div>
                </div>
              </template>
            </div>

            <!-- 底栏：与积分充值弹窗一致 -->
            <div
              v-if="sideNav === 'balance'"
              class="shrink-0 border-t border-white/[0.05] px-6 py-4"
            >
              <p class="mb-3 text-center text-[11px] text-white/35 sm:text-left">
                积分可用于对话、图像与视频生成；充值后请在明细列表查看变动
              </p>
              <div class="flex justify-center sm:justify-end">
                <button
                  type="button"
                  class="bbm-pay-btn inline-flex min-w-[200px] items-center justify-center gap-2 rounded-full px-8 py-3 text-[15px] font-bold text-[#0c0c0e] transition active:scale-[0.99]"
                  @click="onBuyCredits"
                >
                  <span class="bbm-pay-play" aria-hidden="true">
                    <i class="fas fa-coins text-[10px]"></i>
                  </span>
                  购买积分
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 弹窗左下角：退出登录（移动端；桌面端侧栏亦有） -->
        <div
          class="bb-panel-footer shrink-0 border-t border-white/[0.05] px-4 py-3 sm:hidden"
        >
          <button
            type="button"
            class="bb-logout-btn inline-flex items-center gap-2 text-[12px] text-red-400/85 transition hover:text-red-300"
            @click="onLogout"
          >
            <i class="fas fa-right-from-bracket text-[11px]"></i>
            退出登录
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  balanceBillingGate,
  closeBalanceBillingModal,
  clearBalanceBillingPending
} from '../utils/balanceBillingGate'
import { hasAuthToken, loginGate, logoutUser } from '../utils/loginGate'
import {
  fetchBalanceSummary,
  fetchScoreRecords,
  updateUserProfile,
  uploadUserAvatar,
  redeemCodeCard,
  getApiErrorMessage
} from '../utils/balanceBillingApi'

const EMPTY_SUMMARY = {
  name: '用户',
  avatar: '',
  total: 0,
  generalAvailable: 0,
  generalFrozen: 0,
  modelAvailable: 0,
  modelFrozen: 0,
  subscription: 0,
  topup: 0,
  other: 0,
  vipname: 'FREE',
  vipEndAt: '',
  levelLabel: 'FREE 工作室',
  isMember: false
}

export default {
  name: 'BalanceBillingModal',
  data() {
    return {
      balanceBillingGate,
      loginGate,
      sideNav: 'balance',
      filterType: 'all',
      recordFilterTabs: [
        { key: 'all', label: '全部' },
        { key: 'consume', label: '消耗' },
        { key: 'gain', label: '获得' }
      ],
      summary: { ...EMPTY_SUMMARY },
      records: [],
      recordsPage: 1,
      recordsPageSize: 20,
      recordsHasMore: true,
      recordsLoading: false,
      recordsLoadingMore: false,
      recordsLoadPromise: null,
      recordsReqSeq: 0,
      loadPromise: null,
      sideNavItems: [
        { key: 'balance', label: '余额与账单' },
        { key: 'profile', label: '编辑资料' },
        { key: 'invite', label: '邀请好友' },
        { key: 'redeem', label: '卡密兑换' }
      ],
      profileForm: { name: '', avatar: '' },
      profileSaving: false,
      profileError: '',
      profileSuccess: '',
      avatarUploading: false,
      redeemForm: { code: '' },
      redeemSubmitting: false,
      redeemError: '',
      redeemSuccess: ''
    }
  },
  computed: {
    panelTitle() {
      const item = this.sideNavItems.find(i => i.key === this.sideNav)
      return (item && item.label) || '余额与账单'
    },
    statItems() {
      return [
        { key: 'sub', label: '订阅', value: this.summary.subscription, tip: '订阅套餐发放的积分' },
        { key: 'top', label: '充值', value: this.summary.topup, tip: '充值获得的积分' },
        { key: 'oth', label: '其他', value: this.summary.other, tip: '活动、奖励等其他来源' }
      ]
    },
    vipnameBadgeClass() {
      const name = String(this.summary.vipname || 'FREE').trim().toLowerCase()
      if (/free|免费|工作室/.test(name)) return 'bbm-vip-badge--free'
      if (/标准|standard|基础|basic/.test(name)) return 'bbm-vip-badge--standard'
      if (/专业|pro|高级|plus/.test(name)) return 'bbm-vip-badge--pro'
      if (/旗舰|ultra|max|尊享|ultimate/.test(name)) return 'bbm-vip-badge--flagship'
      if (this.summary.isMember) return 'bbm-vip-badge--member'
      return 'bbm-vip-badge--free'
    }
  },
  watch: {
    'balanceBillingGate.visible'(v) {
      if (typeof document === 'undefined') return
      document.body.style.overflow = v ? 'hidden' : ''
      if (v) {
        this.recordsReqSeq += 1
        this.sideNav = 'balance'
        this.filterType = 'all'
        this.records = []
        this.profileError = ''
        this.profileSuccess = ''
        this.redeemError = ''
        this.redeemSuccess = ''
        this.redeemForm = { code: '' }
        this.refresh()
      }
    },
    sideNav(key) {
      if (key === 'profile') this.syncProfileForm()
    },
    'loginGate.visible'(v) {
      if (v || !balanceBillingGate.pendingOpen) return
      if (!hasAuthToken()) return
      clearBalanceBillingPending()
      this.$nextTick(() => {
        balanceBillingGate.visible = true
        this.refresh()
      })
    }
  },
  mounted() {
    if (this.balanceBillingGate.visible) {
      document.body.style.overflow = 'hidden'
      this.refresh()
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') document.body.style.overflow = ''
  },
  methods: {
    formatNum(n) {
      const v = Number(n)
      if (!Number.isFinite(v)) return '0'
      return v.toLocaleString('en-US')
    },
    formatChange(n) {
      const v = Number(n)
      if (!Number.isFinite(v) || v === 0) return '0'
      return v > 0 ? `+${this.formatNum(v)}` : String(this.formatNum(v))
    },
    formatDate(s) {
      if (!s) return '—'
      const d = new Date(s)
      if (Number.isNaN(d.getTime())) return String(s).slice(0, 16)
      const pad = x => String(x).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    formatVipEndAt(s) {
      if (!s) return '—'
      const d = new Date(s)
      if (Number.isNaN(d.getTime())) {
        const raw = String(s).trim()
        return raw.length >= 10 ? raw.slice(0, 10) : raw
      }
      const pad = x => String(x).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
    onClose() {
      closeBalanceBillingModal()
      clearBalanceBillingPending()
    },
    onLogout() {
      if (!confirm('确定退出登录吗？')) return
      closeBalanceBillingModal()
      clearBalanceBillingPending()
      logoutUser()
    },
    onBuyCredits() {
      this.onClose()
      this.$router
        .push({ path: '/pricing', query: { recharge: '1' } })
        .catch(() => {})
    },
    onUpgrade() {
      this.onClose()
      this.$router.push('/pricing').catch(() => {})
    },
    onSideNav(key) {
      this.sideNav = key
      this.profileError = ''
      this.profileSuccess = ''
      this.redeemError = ''
      this.redeemSuccess = ''
      if (key === 'profile') this.syncProfileForm()
    },
    setRecordFilter(key) {
      if (!key || this.filterType === key) return
      this.filterType = key
      this.records = []
      const el = this.$refs.recordsScrollEl
      if (el) el.scrollTop = 0
      this.loadRecords({ reset: true })
    },
    filterRecordsByType(list, filterType) {
      const rows = list || []
      if (filterType === 'consume') return rows.filter(r => Number(r.change) < 0)
      if (filterType === 'gain') return rows.filter(r => Number(r.change) > 0)
      return rows
    },
    syncProfileForm() {
      this.profileForm = {
        name: this.summary.name || '',
        avatar: this.summary.avatar || ''
      }
    },
    async onAvatarFileChange(e) {
      const file = e && e.target && e.target.files && e.target.files[0]
      if (e && e.target) e.target.value = ''
      if (!file) return
      this.profileError = ''
      this.profileSuccess = ''
      this.avatarUploading = true
      try {
        const url = await uploadUserAvatar(file)
        this.profileForm.avatar = url
        this.profileSuccess = '头像已上传，请点击保存资料'
      } catch (err) {
        this.profileError = getApiErrorMessage(err, '头像上传失败')
      } finally {
        this.avatarUploading = false
      }
    },
    async saveProfile() {
      const name = (this.profileForm.name || '').trim()
      if (!name) {
        this.profileError = '请输入昵称'
        return
      }
      if (this.profileSaving) return
      this.profileSaving = true
      this.profileError = ''
      this.profileSuccess = ''
      try {
        await updateUserProfile({
          name,
          avatar: (this.profileForm.avatar || '').trim()
        })
        this.summary = {
          ...this.summary,
          name,
          avatar: (this.profileForm.avatar || '').trim()
        }
        this.profileSuccess = '资料已保存'
      } catch (e) {
        this.profileError = getApiErrorMessage(e, '保存失败，请稍后重试')
      } finally {
        this.profileSaving = false
      }
    },
    resolveRedeemSuccessMessage(res) {
      if (!res || typeof res !== 'object') return '兑换成功'
      const msg = res.message || res.msg
      if (msg && String(msg).trim()) return String(msg).trim()
      const d = res.data
      if (d && typeof d === 'object') {
        const inner = d.message || d.msg
        if (inner && String(inner).trim()) return String(inner).trim()
      }
      return '兑换成功，积分已到账'
    },
    async submitRedeemCode() {
      const code = String(this.redeemForm.code || '').trim()
      if (!code) {
        this.redeemError = '请输入卡密'
        return
      }
      if (this.redeemSubmitting) return
      this.redeemSubmitting = true
      this.redeemError = ''
      this.redeemSuccess = ''
      try {
        const res = await redeemCodeCard(code)
        this.redeemSuccess = this.resolveRedeemSuccessMessage(res)
        this.redeemForm.code = ''
        await this.refresh()
      } catch (e) {
        this.redeemError = getApiErrorMessage(e, '兑换失败，请检查卡密是否正确')
      } finally {
        this.redeemSubmitting = false
      }
    },
    mergeRecords(existing, incoming) {
      const ids = new Set(existing.map(r => r.id))
      const extra = (incoming || []).filter(r => r && !ids.has(r.id))
      return existing.concat(extra)
    },
    onRecordsScroll(e) {
      const el = (e && e.target) || this.$refs.recordsScrollEl
      if (!el || this.recordsLoading || this.recordsLoadingMore || !this.recordsHasMore) return
      const threshold = 56
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
        this.loadRecords({ reset: false })
      }
    },
    loadRecords(opts = {}) {
      const reset = opts.reset !== false
      if (!hasAuthToken()) return Promise.resolve()
      if (!reset && (!this.recordsHasMore || this.recordsLoadingMore || this.recordsLoading)) {
        return Promise.resolve()
      }
      if (this.recordsLoadPromise && !reset) return this.recordsLoadPromise

      const page = reset ? 1 : this.recordsPage
      const reqSeq = ++this.recordsReqSeq
      const filterType = this.filterType

      if (reset) {
        this.recordsLoading = true
        this.recordsHasMore = true
        this.recordsPage = 1
      } else {
        this.recordsLoadingMore = true
      }

      this.recordsLoadPromise = fetchScoreRecords({
        page,
        limit: this.recordsPageSize,
        filterType
      })
        .then(({ list, hasMore }) => {
          if (reqSeq !== this.recordsReqSeq) return
          const rows = this.filterRecordsByType(list, filterType)
          if (reset) this.records = rows
          else this.records = this.mergeRecords(this.records, rows)
          this.recordsHasMore = !!hasMore
          if (hasMore) this.recordsPage = page + 1
        })
        .catch(e => {
          if (reqSeq !== this.recordsReqSeq) return
          if (reset) this.records = []
          this.recordsHasMore = false
          if (process.env.NODE_ENV === 'development') {
            console.warn('[balance-records]', getApiErrorMessage(e, '加载积分明细失败'))
          }
        })
        .finally(() => {
          if (reqSeq !== this.recordsReqSeq) return
          this.recordsLoading = false
          this.recordsLoadingMore = false
          this.recordsLoadPromise = null
        })

      return this.recordsLoadPromise
    },
    refresh() {
      if (!hasAuthToken()) return
      if (this.loadPromise) return this.loadPromise
      this.loadPromise = Promise.all([
        fetchBalanceSummary().catch(e => {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[balance]', getApiErrorMessage(e, '加载余额失败'))
          }
          return { ...EMPTY_SUMMARY }
        }),
        this.loadRecords({ reset: true })
      ]).then(([summary]) => {
        this.summary = { ...EMPTY_SUMMARY, ...summary }
      }).finally(() => {
        this.loadPromise = null
      })
      return this.loadPromise
    }
  }
}
</script>

<style scoped>
.balance-billing-fade-enter-active,
.balance-billing-fade-leave-active {
  transition: opacity 0.22s ease;
}
.balance-billing-fade-enter,
.balance-billing-fade-leave-to {
  opacity: 0;
}
.balance-billing-panel {
  height: 680px;
  max-height: calc(100vh - 32px);
  box-shadow:
    0 32px 80px rgba(0, 0, 0, 0.65),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset;
}
@media (max-width: 640px) {
  .balance-billing-panel {
    height: min(680px, calc(100vh - 24px));
  }
}

.bbm-coin-icon {
  filter: drop-shadow(0 0 6px rgba(251, 191, 36, 0.35));
}

.bbm-stat-card {
  background: linear-gradient(160deg, rgba(28, 28, 32, 0.95) 0%, rgba(14, 14, 16, 0.98) 100%);
}
.bbm-stat-card::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
}
.bbm-stat-grid .bbm-stat-card {
  position: relative;
  overflow: hidden;
}
.bbm-stat-grid .bbm-stat-card::before {
  background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255, 255, 255, 0.04), transparent 70%);
}

.bb-nav-btn,
.bb-logout-btn {
  border: none;
  cursor: pointer;
  background: transparent;
}

.bbm-pay-btn {
  border: none;
  cursor: pointer;
  background: linear-gradient(90deg, #a5f3fc 0%, #fef3c7 42%, #fde68a 100%);
  box-shadow:
    0 4px 24px rgba(165, 243, 252, 0.25),
    0 2px 8px rgba(0, 0, 0, 0.35);
}
.bbm-pay-btn:hover {
  filter: brightness(1.05);
  box-shadow:
    0 6px 28px rgba(165, 243, 252, 0.35),
    0 2px 10px rgba(0, 0, 0, 0.4);
}
.bbm-pay-play {
  display: inline-flex;
  height: 22px;
  width: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: linear-gradient(135deg, #22d3ee, #fb923c);
  color: #0c0c0e;
}

/* 会员等级色标 */
.bbm-vip-badge--free {
  color: rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.bbm-vip-badge--standard {
  color: #6ee7b7;
  background: rgba(16, 185, 129, 0.14);
  border: 1px solid rgba(52, 211, 153, 0.28);
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.12);
}
.bbm-vip-badge--pro {
  color: #fdba74;
  background: rgba(251, 146, 60, 0.14);
  border: 1px solid rgba(251, 146, 60, 0.3);
  box-shadow: 0 0 12px rgba(251, 146, 60, 0.12);
}
.bbm-vip-badge--flagship {
  color: #fda4af;
  background: rgba(244, 63, 94, 0.14);
  border: 1px solid rgba(248, 113, 113, 0.32);
  box-shadow: 0 0 12px rgba(244, 63, 94, 0.14);
}
.bbm-vip-badge--member {
  color: #7dd3fc;
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(125, 211, 252, 0.28);
}

.bbm-table-scroll {
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
}
.bbm-table-scroll::-webkit-scrollbar {
  width: 6px;
}
.bbm-table-scroll::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.18);
}
.bbm-table-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.bbm-field {
  display: block;
}
.bbm-field__label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
}
.bbm-field__input {
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(160deg, rgba(28, 28, 32, 0.95) 0%, rgba(14, 14, 16, 0.98) 100%);
  padding: 12px 14px;
  font-size: 14px;
  color: #fff;
  outline: none;
  transition: border-color 0.2s ease;
}
.bbm-field__input::placeholder {
  color: rgba(255, 255, 255, 0.28);
}
.bbm-field__input:focus {
  border-color: rgba(34, 211, 238, 0.35);
}
.bbm-field__input--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  letter-spacing: 0.03em;
}

/* 头像上传：图2 渐变圆 + 右下角编辑钮 */
.bbm-avatar-picker {
  position: relative;
  display: block;
  width: 96px;
  height: 96px;
  padding: 0;
  border: none;
  cursor: pointer;
  background: transparent;
}
.bbm-avatar-picker--disabled {
  cursor: wait;
  opacity: 0.85;
  pointer-events: none;
}
.bbm-avatar-picker__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
.bbm-avatar-picker__ring {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  overflow: hidden;
  border-radius: 50%;
  background: linear-gradient(145deg, #6b6358 0%, #4a5563 42%, #2d3a47 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}
.bbm-avatar-picker__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bbm-avatar-picker__placeholder {
  font-size: 2.25rem;
  color: rgba(255, 255, 255, 0.38);
}
.bbm-avatar-picker__loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  color: rgba(255, 255, 255, 0.9);
}
.bbm-avatar-picker__edit {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: #0a0a0a;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
  pointer-events: none;
}
.bbm-avatar-picker:hover .bbm-avatar-picker__ring {
  filter: brightness(1.06);
}
.bbm-avatar-picker:hover .bbm-avatar-picker__edit {
  border-color: rgba(255, 255, 255, 0.35);
}
</style>
